$shm_hitalama_vk_posts_table $shm_hitalama_vk_posts_multi
	Sub <= Table $shm_hitalama_table
		head /
			<= Head_id $mol_view sub / \Id
			<= Head_date $mol_view sub / \Дата и время
			<= Head_likes $mol_view sub / \Лайки
			<= Head_reposts $mol_view sub / \Репосты
			<= Head_comments $mol_view sub / \Комментарии
			<= Head_views $mol_view sub / \Просмотры
		rows <= posts_rows /
			<= Post_row*0 $mol_view
				sub /
					<= Post_id* $mol_paragraph title <= post_id*
					<= Post_date* $mol_paragraph title <= post_date*
					<= Post_likes* $mol_paragraph title <= post_likes*
					<= Post_reposts* $mol_paragraph title <= post_reposts*
					<= Post_comments* $mol_paragraph title <= post_comments*
					<= Post_views* $mol_paragraph title <= post_views*
